import React from 'react';
import rootStore from '../../RootStore';
import GQFlag from '../GQFlag';
import classNames from 'classnames';

interface IGQCountryButtonProps {
    id: number;
    isSelected: boolean;
    onClick?: (id: number) => void;
    style?: React.CSSProperties;
}

export default class GQCountryButton
    extends React.Component<IGQCountryButtonProps> {
    public render() {
        const { id, isSelected, style, } = this.props;
        const containerClass = classNames(['flag-container'], {
            active: isSelected,
        });
        return (
            <div className="gq-country-button">
                <div
                    onClick={this.onClick}
                    className={containerClass}
                    style={
                        isSelected
                            ? {
                                  ...style,
                                  borderColor:
                                      (style && style.borderColor) ||
                                      rootStore.countryStore.colorStack.color(
                                          id
                                      ),
                                  transition: 'border .4s ease',
                              }
                            : {}
                    }>
                    <GQFlag countryId={id} className="flag-icon-squared" />
                </div>
            </div>
        );
    }
    private onClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (this.props.onClick) {
            this.props.onClick(this.props.id);
        }
    };
}
